import React, { useState, useEffect, useRef } from "react";
import { XMasonry, XBlock } from "react-xmasonry";

const useOnScreen = (ref, setActiveHeader, id) => {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting === true) setActiveHeader(id);
      },
      { rootMargin: "0px 0px -300px 0px" }
    );

    observer.observe(ref.current);
    return () => {
      observer.disconnect();
    };
  }, [id, ref, setActiveHeader]);
};

const InnerGallery = ({ companyImageGallery, setActiveHeader }) => {
  const id = "gallery";
  const ref = useRef();
  useOnScreen(ref, setActiveHeader, id);

  return (
    <div ref={ref} id={id}>
      <XMasonry>
        {companyImageGallery.map((item) => (
          <XBlock key={item.id}>
            <div className="p-2">
              <img className="rounded-md" src={item.image} alt="" />
            </div>
          </XBlock>
        ))}
      </XMasonry>
    </div>
  );
};

const ImageGallery = ({ companyImageGallery, setActiveHeader }) => {
  const [hasMounted, setHasMounted] = useState(false);
  useEffect(() => {
    setHasMounted(true);
  }, []);
  if (!hasMounted) return null;

  return (
    <InnerGallery
      companyImageGallery={companyImageGallery}
      setActiveHeader={setActiveHeader}
    />
  );
};

export default ImageGallery;
